import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDByfrQMApyBhI_6gPvVmqvuGP3bpVe7Fs",
  authDomain: "rva-acs.firebaseapp.com",
  projectId: "rva-acs",
  storageBucket: "rva-acs.firebasestorage.app",
  messagingSenderId: "246274450722",
  appId: "1:246274450722:web:17894c26251838a50fb17b"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export async function loadData(key, fallback) {
  try {
    const snap = await getDoc(doc(db, "schedule", key));
    if (snap.exists()) return snap.data().value;
    return fallback;
  } catch (e) {
    console.error("Load error:", e);
    return fallback;
  }
}

export async function saveData(key, value) {
  try {
    await setDoc(doc(db, "schedule", key), { value: value, updatedAt: new Date().toISOString() });
  } catch (e) {
    console.error("Save error:", e);
  }
}
